/**
 * インタビューアーカイブの「もっと見る」機能
 */

const initArchiveInterviewLoadMore = () => {
  const loadMoreBtn = document.getElementById('js-load-more');
  const container = document.querySelector('.p-archive-interview__posts');

  if (!loadMoreBtn || !container || !window.archiveAjax) {
    return;
  }

  let currentPage = 1;
  let isLoading = false;

  loadMoreBtn.addEventListener('click', async (e) => {
    e.preventDefault();

    if (isLoading) {
      return;
    }

    isLoading = true;
    loadMoreBtn.disabled = true;

    try {
      const nextPage = currentPage + 1;

      const formData = new FormData();
      formData.append('action', 'load_more_posts');
      formData.append('nonce', window.archiveAjax.nonce);
      formData.append('page', nextPage);
      formData.append('post_type', window.archiveAjax.post_type);
      formData.append('posts_per_page', window.archiveAjax.posts_per_page);

      const interviewTermId =
        window.archiveAjax.interview_category_term_id != null
          ? Number(window.archiveAjax.interview_category_term_id)
          : 0;
      if (interviewTermId > 0) {
        formData.append(
          'interview_category_term_id',
          String(interviewTermId),
        );
      }

      const response = await fetch(window.archiveAjax.ajax_url, {
        method: 'POST',
        body: formData,
      });

      const data = await response.json();

      if (data.success && data.data.html) {
        container.insertAdjacentHTML('beforeend', data.data.html);
        currentPage++;

        // 追加された要素だけを新たに observe してフェードインさせる
        const newItems = container.querySelectorAll('[data-fadein]:not(.is-show)');
        newItems.forEach((el) => {
          if (window.observeFadeinElement) {
            window.observeFadeinElement(el);
          }
        });

        if (!data.data.has_more) {
          loadMoreBtn.style.display = 'none';
        } else {
          loadMoreBtn.disabled = false;
        }
      } else {
        loadMoreBtn.disabled = false;
      }
    } catch (error) {
      loadMoreBtn.disabled = false;
    } finally {
      isLoading = false;
    }
  });
};

initArchiveInterviewLoadMore();

